import StvJaNeinUnbekannt from "../../../../../../consumer/form/dto/StvJaNeinUnbekannt";
import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";

import InputValidator from "../../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";

export default class VorschadenValidator implements InputValidatorI {

    private value?: StvJaNeinUnbekannt;

    constructor(newValue?: StvJaNeinUnbekannt) {
        this.value = newValue;
    }

    validate() {
        // *** exist value
        if (!InputValidator.existValue(this.value)) {
            return InputValidationStateBo.createInValid("Bitte machen Sie Angaben zu Ihren Vorschäden.");
        }

        if (this.value === StvJaNeinUnbekannt.UNBEKANNT) {
            return InputValidationStateBo.createInValid("Bitte machen Sie Angaben zu Ihren Vorschäden.");
        }
        /*
        if (this.value !== StvJaNeinUnbekannt.NEIN) {
            return InputValidationStateBo.createInValid("");
        }
        */

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }
}